type PillColorCaps = 'GREEN' | 'RED' | 'WHITE';

export type PillColor = 'green' | 'red' | 'white';

export const PILL_COLORS: Record<PillColorCaps, PillColor> = {
  GREEN: 'green',
  RED: 'red',
  WHITE: 'white'
};
